export default __webpack_public_path__ + "static/media/hotel-resort-img-13.fbdf5aaa.jpg";